module.exports = __webpack_public_path__ + "img/health-care-list-image.77813db1.png";